import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingMedicalRecordSummaryType,
    deleteMedicalRecordSummaryType,
    saveOrUpdateMedicalRecordSummaryType,
    getMedicalRecordSummaryTypeById,
    getAllMedicalRecordSummaryType
} from 'app/services/MedicalRecordSummaryTypeService';

import { MedicalRecordSummaryType } from "app/common/Model/MedicalRecordSummaryType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class MedicalRecordSummaryTypeStore {
    listAllMedicalRecordSummaryType = [];
    searchMedicalRecordSummaryType = new SearchObject();
    pageMedicalRecordSummaryType = null;
    selectedMedicalRecordSummaryType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteMedicalRecordSummaryType = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllMedicalRecordSummaryType = () => {
        if (this.listAllMedicalRecordSummaryType?.length === 0) {
            pagingMedicalRecordSummaryType({ pageIndex: 1, pageSize: PAGESIZE_ALL }).then(({ data }) => {
                this.listAllMedicalRecordSummaryType = data.content;
            })
        }
    }

    pagingMedicalRecordSummaryType = () => {
        pagingMedicalRecordSummaryType(this.searchMedicalRecordSummaryType).then(({ data }) => {
            this.pageMedicalRecordSummaryType = data;
        })
    }

    handleChangeFormSearch = (searchMedicalRecordSummaryType) => {
        this.searchMedicalRecordSummaryType = checkSearchObject(this.searchMedicalRecordSummaryType, searchMedicalRecordSummaryType);
        this.pagingMedicalRecordSummaryType();
    }

    handleOpenFormCreateOrEdit = (medicalRecordSummaryTypeById) => {
        if (Boolean(medicalRecordSummaryTypeById)) {
            getMedicalRecordSummaryTypeById(medicalRecordSummaryTypeById).then(({ data }) => {
                this.selectedMedicalRecordSummaryType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedMedicalRecordSummaryType = new MedicalRecordSummaryType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveMedicalRecordSummaryType = (medicalRecordSummaryType, { setSubmitting }) => {
        saveOrUpdateMedicalRecordSummaryType(medicalRecordSummaryType).then(() => {
            this.selectedMedicalRecordSummaryType = null;
            toast.success("Lưu kiểu thăm khám thành công!");
            this.pagingMedicalRecordSummaryType();
            this.handleClosePopup();
            this.listAllMedicalRecordSummaryType = [];
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu kiểu thăm khám thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteMedicalRecordSummaryType = (medicalRecordSummaryType) => {
        this.selectedMedicalRecordSummaryType = { id: medicalRecordSummaryType?.id };
        this.openConfirmDeleteMedicalRecordSummaryType = true;
    }

    handleConfirmDeleteMedicalRecordSummaryType = () => deleteMedicalRecordSummaryType(this.selectedMedicalRecordSummaryType?.id)
        .then(() => {
            if (this.searchMedicalRecordSummaryType?.pageIndex > 1 && this.pageMedicalRecordSummaryType?.content?.length === 1) {
                this.searchMedicalRecordSummaryType.pageIndex -= 1;
            }
            toast.success("Xóa kiểu thăm khám thành công!");
            this.pagingMedicalRecordSummaryType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa kiểu thăm khám thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalRecordSummaryType = false;
    }

    resetStore = () => {
        this.searchMedicalRecordSummaryType = new SearchObject();
        this.pageMedicalRecordSummaryType = null;
        this.selectedMedicalRecordSummaryType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalRecordSummaryType = false;
    }
}